import { CSSObject } from '@emotion/react';

export const AutoCompleteResult: CSSObject = {
  fontSize: 'xs',
};
